<script setup lang="ts">
import { useVoixToast } from '@voix/composables/useVoixToast'

import VoixToast from './VoixToast.vue'

const { messages } = useVoixToast()
</script>

<template>
  <div class="space-y-2">
    <VoixToast
      v-for="message in messages"
      :key="message.id"
      :message="message"
    />
  </div>
</template>
